module.exports = __webpack_public_path__ + "img/base_img.ae15419e.png";